import type { CSSProperties } from 'react';

export function fmtDate(iso: string) {
  try { return new Date(iso).toLocaleString('pt-BR'); } catch { return iso; }
}

export function prettyJson(raw: string | null | undefined) {
  if (!raw) return '';
  try { return JSON.stringify(JSON.parse(raw), null, 2); } catch { return raw; }
}

export const jsonPreStyle: CSSProperties = {
  fontSize: 11, whiteSpace: 'pre-wrap', wordBreak: 'break-all',
  maxHeight: 260, overflow: 'auto', margin: '4px 0 0',
  background: '#0000000a', padding: 8, borderRadius: 4,
};
